import { linkDeContato, normalizarTelefoneBR } from '@entregas/core';
import { Icone } from './Icone';
import css from './LinkDeContato.module.css';

interface PropsLinkDeContato {
  telefone: string | null;
  rotulo: string;
  mensagem?: string;
  /**
   * `auto`: celular abre o WhatsApp, fixo vira ligação. `whatsapp`: só celular (fixo não aparece).
   * `ligar`: ligação para qualquer número.
   */
  tipo?: 'auto' | 'whatsapp' | 'ligar';
  /** Nome para leitor de tela quando o rótulo sozinho é curto ("Cliente" → "WhatsApp da Maria"). */
  rotuloAcessivel?: string;
}

/** "Falar com": ícone e texto, nunca o mesmo botão de uma ação (decisão B3). Sem número, nada. */
export function LinkDeContato({
  telefone,
  rotulo,
  mensagem,
  tipo = 'auto',
  rotuloAcessivel,
}: PropsLinkDeContato) {
  const contato = tipo === 'ligar' ? ligacao(telefone) : linkDeContato(telefone, mensagem);
  if (!contato || (tipo === 'whatsapp' && contato.tipo !== 'whatsapp')) return null;
  const whatsapp = contato.tipo === 'whatsapp';

  return (
    <a
      href={contato.url}
      className={css.link}
      aria-label={rotuloAcessivel}
      {...(whatsapp && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      <Icone nome={whatsapp ? 'conversa' : 'tel'} tamanho={16} />
      {rotulo}
    </a>
  );
}

function ligacao(telefone: string | null) {
  const numero = telefone ? normalizarTelefoneBR(telefone) : null;
  return numero ? { tipo: 'ligar' as const, url: `tel:+${numero}` } : null;
}
